export default __webpack_public_path__ + "static/media/Foebane.e16a6218.jpg";